import { useState } from "react";
import { useEffect } from "react";
import { loadHeroes } from "../http/fetch-status";
import CareerIcon from "./career-icon";
import { weekNumber } from "../utils/constants";
import { BsChevronRight, BsChevronLeft } from "react-icons/bs";

const Hero = () => {
  const defaultWeek = weekNumber;
  const [data, setData] = useState(null);
  const [week, setWeek] = useState(defaultWeek);
  const [weekYear, setWeekYear] = useState(2023 + 0.01 * defaultWeek);

  const fetchData = async () => {
    const response = await loadHeroes();
    console.log(response.data);
    setData(response.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setWeekYear(2024 + 0.01 * week);
  }, [week]);

  const HeroRow = ({ title, subtitle, order, destro }) => {
    return (
      <div className="mb-10">
        <div className="space-y-1 mb-2 text-center">
          <div className="ror-font-only text-[20px] text-center ">{title}</div>
          <div className="text-gray-400 uppercase text-xs text-center">
            {subtitle}
          </div>
        </div>

        <div className="grid grid-cols-2 my-3">
          <div>
            {order.map((c) => {
              return (
                <div className="flex space-x-4 text-sky-400 fontbold my-1">
                  <div className="w-6">
                    <CareerIcon career={c.career} />
                  </div>
                  <div className="w-36">
                    <div>{c.name}</div>
                    <div className="text-[10px] text-gray-400 h-4">
                      {c.guild && `<${c.guild}>`}
                    </div>
                  </div>
                  <div>{c.value}</div>
                </div>
              );
            })}
          </div>
          <div>
            {destro.map((c) => {
              return (
                <div className="flex space-x-6  text-red-400 font-old my-1">
                  <div className="w-6">
                    <CareerIcon career={c.career} />
                  </div>
                  <div className="w-36">
                    <div>{c.name}</div>
                    <div className="text-xxs text-gray-400 h-4">
                      {c.guild && `<${c.guild}>`}
                    </div>
                  </div>
                  <div>{c.value}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  if (!data) {
    return null;
  }

  return (
    <div className="mx-auto">
      <div className="ror-font text-[30px] text-center my-6">
        Warriors of Reckoning
      </div>
      <div className="text-center text-[24px] font-bold uppercase mb-10 flex space-x-5 justify-center items-baseline">
        <div
          className="top-1 relative cursor-pointer"
          onClick={() => setWeek(week - 1)}
        >
          <BsChevronLeft />
        </div>
        <div className="w-40">Week {week}</div>
        <div
          className="top-1 relative cursor-pointer"
          onClick={() => setWeek(week + 1)}
        >
          <BsChevronRight />
        </div>
      </div>
      {data
        .filter((d) => d.week_year == weekYear)
        .map((d) => {
          return (
            <div className="md:grid grid-cols-2">
              {d.data.map((xhero) => {
                return (
                  <>
                    <HeroRow
                      title={xhero.title}
                      subtitle={xhero.subtitle}
                      order={xhero.order}
                      destro={xhero.destro}
                    />
                  </>
                );
              })}
            </div>
          );
        })}
    </div>
  );
};

export default Hero;
